import { TUser } from "~/types";
import { baseService } from "../base";
import { Role } from "~/utils/constants";
import { MetaData } from "~/types/common";

export interface CreateUserRequest {
  username: string;
  email: string;
  firstName?: string;
  lastName?: string;
  userRole: string;
  phoneNumber?: string;
  password: string;
  clientId?: string;
}

export interface UpdateUserRequest {
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  userRole?: string;
  phoneNumber?: string;
  password?: string;
  deactivate?: boolean;
}

export interface GetUsersParams {
  page?: number;
  pageSize?: number;
  roles?: Role[];
  search?: string;
}

export interface UsersResponse {
  items: TUser[];
  meta: MetaData;
  totalItems: number;
  itemCount: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

export const userService = {
  // Get all users with pagination and filters
  getUsers: async (params: GetUsersParams = {}): Promise<UsersResponse> => {
    const { data } = await baseService.get("/users", { params });
    return data;
  },

  // Create a new user
  createUser: async (userData: CreateUserRequest): Promise<TUser> => {
    const { data } = await baseService.post("/users", userData);
    return data;
  },

  // Update a user
  updateUser: async (
    id: string,
    userData: UpdateUserRequest
  ): Promise<TUser> => {
    const { data } = await baseService.patch(`/users/${id}`, userData);
    return data;
  },

  // Delete a user
  deleteUser: async (id: string): Promise<void> => {
    await baseService.delete(`/users/${id}`);
  },
};
